import { memo } from 'react';

const InformationIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2.18688L22.3503 22.025L1.64966 22.025L12 2.18688Z"
      fill="#E7B93C"
      stroke="black"
      strokeWidth="2"
    />
    <rect
      x="12.5"
      y="15.5"
      width="1"
      height="7"
      rx="0.5"
      transform="rotate(-180 12.5 15.5)"
      fill="#101010"
      stroke="#101010"
    />
    <rect
      x="12.5"
      y="19.4998"
      width="0.999997"
      height="1.45454"
      rx="0.499999"
      transform="rotate(-180 12.5 19.4998)"
      fill="#101010"
      stroke="#101010"
      strokeWidth="0.999997"
    />
  </svg>
);

export default memo(InformationIcon);
